<div class="change__pin-container">
  <div class="change__pin-header">
    <h5>{{ data?.title }}</h5>
    <div class="web__close-icon">
      <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  </div>
  <div class="change__pin-form">
    @if (data.openedFrom == 'shareLink') {
      <form [formGroup]="changePinForm">
        <mat-form-field appearance="fill" class="form-design-ui">
          <mat-label class="automtic-form-desing-lable"> PIN </mat-label>
          <input type="number" matInput formControlName="pin" (input)="handleInput($event)" />
          @if (!changePinForm.controls['pin'].value) {
            <mat-error> PIN address is required. </mat-error>
          }
          @if (changePinForm.controls['pin'].value && (changePinForm.controls['pin'].dirty || changePinForm.controls['pin'].touched)) {
            <mat-error>
            </mat-error>
          }
        </mat-form-field>
        <p
          [class]="screenWidth > 480 ? 'mt-2' : 'mt-3'"
          [style.color]="changePinForm.controls['pin'].value && changePinForm.invalid ? '#EB5757' : '#010B18'"
          >
          PIN must be between 4-6 numbers
        </p>
        <div>
          <button
            (click)="updateVaultUserFormLink()"
            [class]="changePinForm.valid ? 'app__btn--primary mb-0 mt-5 rounded-lg' : 'app__btn--disabled mb-0 mt-5 rounded-lg'"
            >
            Save
          </button>
        </div>
      </form>
    }
    @if (data.openedFrom == 'financialAttribute') {
      <form [formGroup]="financialAttributeForm">
        <input-number-effect
          [fromPurchasePrice]="true"
          [showLabel]="true"
          [title]="data?.title"
          (newValue)="getValue($event)"
          initial="{{ financialAttributeForm.controls['value'].value | number : '1.2-2' }}"
          (focus)="selectAllContent($event)"
          >
        </input-number-effect>
        <mat-form-field appearance="fill" class="form-design-ui mt-4">
          <mat-label class="automtic-form-desing-lable"> Effective Date </mat-label>
          <input matInput [matDatepicker]="effectiveDate" (click)="effectiveDate.open()" formControlName="effective_date" />
          <mat-datepicker-toggle matSuffix [for]="effectiveDate"></mat-datepicker-toggle>
          <mat-datepicker #effectiveDate disabled="false"></mat-datepicker>
        </mat-form-field>
        <div>
          <button
            (click)="data.mode == 'create' ? createVaultUserFormPurchasePrice() : updateVaultUserFormPurchasePrice()"
          [class]="
            financialAttributeForm.valid && financialAttributeForm.controls['value'].value != 0
              ? 'app__btn--primary mb-0 mt-5 rounded-lg'
              : 'app__btn--disabled mb-0 mt-5 rounded-lg'
          "
            >
            Save
          </button>
        </div>
      </form>
    }
  </div>
</div>
